var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (all, correct, image, title, undefined) {
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
buf.push("<div class=\"game-image-title text-center text-bold text-lg\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</div><div class=\"game-box-inner content-fill block-v-lg\"><div class=\"row content-fill\"><div class=\"col-md-4 col-sm-4 content-fill\"><div class=\"block-dk content-fill\"><div class=\"block-md game-image-container text-center\">");
jade_mixins["image"](image,'game-image');
buf.push("</div></div></div><div class=\"col-md-8 col-sm-8 content-fill\"><div class=\"block-flex-ver text-md direction-column\">");
// iterate all
;(function(){
  var $$obj = all;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var attribute = $$obj[i];

buf.push("<div" + (jade.attr("data-is-correct", correct.indexOf(attribute) > -1, true, false)) + (jade.attr("data-index", i, true, false)) + " class=\"btn-attribute block-flex-child block-flex-ver\"><h2 class=\"block-h-md btn-text\">" + (null == (jade_interp = attribute) ? "" : jade_interp) + "</h2></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var attribute = $$obj[i];

buf.push("<div" + (jade.attr("data-is-correct", correct.indexOf(attribute) > -1, true, false)) + (jade.attr("data-index", i, true, false)) + " class=\"btn-attribute block-flex-child block-flex-ver\"><h2 class=\"block-h-md btn-text\">" + (null == (jade_interp = attribute) ? "" : jade_interp) + "</h2></div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div>");}.call(this,"all" in locals_for_with?locals_for_with.all:typeof all!=="undefined"?all:undefined,"correct" in locals_for_with?locals_for_with.correct:typeof correct!=="undefined"?correct:undefined,"image" in locals_for_with?locals_for_with.image:typeof image!=="undefined"?image:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}